// extracted by mini-css-extract-plugin
export var button = "index-module--button--oagSo";
export var isBlock = "index-module--isBlock--xHQ2I";
export var primary = "index-module--primary--O7pCq";
export var transparent = "index-module--transparent--B6zLz";
export var large = "index-module--large--7aSLi";
export var small = "index-module--small--+qPEf";
export var disabled = "index-module--disabled--73oki";